(function($){
	$(document).ready(()=>{
		function setHtmlScroll(trigger, triggerSelector, overflow) {
			const $html = $('html');

			$(document).on(trigger, triggerSelector, (e)=> {
				if($(e.target).is(triggerSelector)) {
					$html.css({
						'overflow-y' : overflow
					});
				}
			});
		}

		setHtmlScroll('click', '.js-oneclick', 'hidden');
		setHtmlScroll('click', '.mfp-close, .mfp-close .icon-close', 'auto');
		setHtmlScroll('click', '.mfp-container', 'auto');
		setHtmlScroll('click', '.mfp-content', 'auto');

		function initBuyOneClickClose() {
			$(document).on('click', '.mfp-close, .mfp-close .icon-close', function (e) {
				e.preventDefault();
				$.magnificPopup.close();
				$('html').css('overflow-y', 'auto');
			});
		}

		function initBuyOneClickForm() {
			$(document).on('submit', '.oneClickForm', function (e) {
				e.preventDefault();

				const $form = $(this);
				const submitButton = $form.find('button[type="submit"]');
				const $errors = $form.find('.js-form-errors');

				submitButton.attr('disabled', true);
				submitButton.css({ color: 'transparent' });
				submitButton.find('.btn-default__loading').addClass('btn-default__loading--visible');

				$.ajax({
					url: $form.attr('action'),
					method: 'POST',
					data: $form.serialize(),
					success: function (response) {
						submitButton.attr('disabled', false);
						submitButton.removeAttr('style');
						submitButton.find('.btn-default__loading').removeClass('btn-default__loading--visible');

						const data = typeof response === 'string' ? JSON.parse(response) : response;

						if (data.order_id) {
							const mask = $form.find('.js-phone-inputmask')[0];

							if (mask && mask.inputmask) {
								mask.inputmask.setValue('0');
							}

							$.magnificPopup.open({
								items: {
									src: '<div id="one-click-success" class="modal zoom-anim-dialog">' + data.text + '</div>',
									type: 'inline'
								}
							});

							if (typeof gtag !== 'undefined') {
								gtag('event', 'click', {
									event_category: 'form',
									event_label: 'buy'
								});
							}

							if (typeof reachGoal === 'function') {
								reachGoal('buy-one-click');
							}
						}

						if (!data.errors || !data.errors.length) {
							$errors.fadeOut();
							return;
						}

						$errors.empty();

						for (let i = 0; i < data.errors.length; i++) {
							$errors.append('<span>' + data.errors[i] + '</span>');
						}

						$errors.fadeIn();
					},
					error: function () {
						submitButton.attr('disabled', false);
						submitButton.removeAttr('style');
						submitButton.find('.btn-default__loading').removeClass('btn-default__loading--visible');
					}
				});
			});
		}

		function initBuyOneClickModal() {
			$(document).on('click', '.js-oneclick', function (e) {
				e.preventDefault();
				const $this = $(this);

				$.magnificPopup.open({
					items: {
						src: '/api/frontend-component/' +
							'?component=realweb:blank&template=one-by-click&type=html&params[ID]=' + $this.attr('data-product'),
						type: 'ajax'
					},
					settings: {cache: false, async: false},
					preloader: false,
					fixedBgPos: true,
					removalDelay: 300,
					fixedContentPos: false,
					mainClass: 'my-mfp-slide-bottom',
					closeMarkup:
						'<button title="%title%" type="button" class="mfp-close modal__close"><i class="icon-close"></i></button>',
					callbacks: {
						ajaxContentAdded: function() {
							const $phone = $('.oneClickForm [name="phone"]');

							initPhoneMask($phone);

							$phone.off('blur.oneClick').on('blur.oneClick', function (event) {
								const unmasked = event.target.inputmask && event.target.inputmask.unmaskedvalue();

								if (!unmasked || unmasked.length < 10) {
									event.target.value = '';
								} else {
									$('.oneClickForm .js-form-errors').fadeOut();
								}
							});
						},
						close: function () {
							$('html').css('overflow-y', 'auto');
						}
					}
				});

				$('body').removeClass('mobile-menu-open main-menu-open');
			});
		}

		initBuyOneClickClose();
		initBuyOneClickForm();
		initBuyOneClickModal();
	});
// eslint-disable-next-line no-undef
})(jQuery);
